'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "onClose"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { View } from 'foundations-components/transitional/components/View';
import PropTypes from 'prop-types';
import { KeyTypes } from '../../constants/popover';
import CalloutTypeList from './CalloutTypeList';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
function CalloutPopoverBodyEdit(props) {
  const {
      onChange,
      onClose
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleCloseOnEscape = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      onClose();
    }
  };
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "294px",
    onKeyDown: handleCloseOnEscape,
    children: /*#__PURE__*/_jsxs(Fieldset, {
      padding: "500",
      tabIndex: "-1",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        align: "baseline",
        justify: "between",
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'RichTextLib.callout.edit.title'
          })
        }), /*#__PURE__*/_jsx(CloseButton, {
          color: "icon-core-subtle",
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(FormControl, {
        label: I18n.text('RichTextLib.callout.edit.subTitle'),
        children: /*#__PURE__*/_jsx(CalloutTypeList, Object.assign({}, rest, {
          paddingInline: "300",
          onClick: onChange
        }))
      })]
    })
  });
}
CalloutPopoverBodyEdit.propTypes = propTypes;
CalloutPopoverBodyEdit.displayName = 'CalloutPopoverBodyEdit';
export default CalloutPopoverBodyEdit;